import * as React from 'react';
import { Layout } from 'react-admin';
import UnityAppBar from './UnityAppBar';

const UnityLayout = (props) => <Layout {...props} appBar={UnityAppBar} />;

export default UnityLayout;